module.exports = __webpack_public_path__ + "img/sph.f340ef54.png";